import { render } from "./AposSubform.vue?vue&type=template&id=0db19be9&scoped=true"
import script from "./AposSubform.vue?vue&type=script&lang=js"
export * from "./AposSubform.vue?vue&type=script&lang=js"

import "./AposSubform.vue?vue&type=style&index=0&id=0db19be9&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0db19be9"],['__file',"schema/ui/apos/components/AposSubform.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0db19be9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0db19be9', __exports__)) {
    api.reload('0db19be9', __exports__)
  }
  
  module.hot.accept("./AposSubform.vue?vue&type=template&id=0db19be9&scoped=true", () => {
    api.rerender('0db19be9', render)
  })

}


export default __exports__